import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import React, { PropsWithChildren, ReactNode } from 'react'

type Props = {
  /**
   * positive integer
   */
  packageNumber: number
  tagLineLabel?: ReactNode
} & ({
  roomPackage?: App.HotelPackage
  promotion?: undefined
} | {
  roomPackage?: undefined
  promotion?: App.BedbankPromotion
})

function AccommodationPackageTileDetails(props: PropsWithChildren<Props>) {
  const {
    children,
    packageNumber,
    tagLineLabel,
    roomPackage,
    promotion,
  } = props

  const name = roomPackage?.name ?? promotion?.name

  return <div>
    <VerticalSpacer gap={4}>
      <VerticalSpacer gap={8}>
        {!!packageNumber && <Caption variant="large">Option {packageNumber}</Caption>}
        {!!tagLineLabel && <LabelGroup>{tagLineLabel}</LabelGroup>}
      </VerticalSpacer>
      {!!name && <Heading variant="heading6">{name}</Heading>}
    </VerticalSpacer>
    {children}
  </div>
}

export default AccommodationPackageTileDetails
